import React from 'react';
import PropTypes from 'prop-types';

const PlanHuman = ({ className }) => (
  // <svg
  //   className={className}
  //   width="1656"
  //   height="1775"
  //   xmlns="http://www.w3.org/2000/svg"
  //   viewBox="0 0 1656 1775"
  //   role="presentation"
  // >
  //   <g fillRule="evenodd">
  //     <path d="M465.692 52l453.847 296.786L1656 349.92l-.809 1406.65V1775H342.267L53 574.898z" />
  //     <path
  //       stroke="#202E5C"
  //       strokeWidth="4"
  //       fill="currentColor"
  //       d="M414.692 2l453.847 296.786L1605 299.92l-.809 1406.65V1725H291.267L2 524.898z"
  //     />
  //     <g className="areas">
  //       <path
  //         fill="#C3DEE7"
  //         d="M364.304 1293.103l10.514 121.803 162.749-14.427-10.514-121.811zM385.452 1481.079l-20.174 117.827 118.042 20.357 20.178-117.828zM912.32 1558.57L967.053 1665l106.847-55.109-54.739-106.43zM642.692 1572.324l103.423 63.482 65.946-107.793-103.423-63.477zM973.643 1010.118l75.672 101.172 114.137-86.65-75.676-101.164zM1163.452 1273.9l23.793 170.2 166.017-23.457-23.796-170.196zM350.677 267.678l121.845 69.975L541.46 213.97 419.615 144zM381.651 337.653L312.715 461.33l121.847 69.975 68.936-123.678zM231.76 476.81L156 595.695l118.918 75.74 75.759-118.888zM164.76 918.264l141.768 6.185 6.187-141.722-141.764-6.193zM384.371 677.274l-36.614 136.612 136.647 36.605 36.615-136.607zM1407.635 1147.296L1436 1012.89l-137.106-28.107-28.37 134.406zM827.183 1118.505c41.68 23.595 135.99 39.672 168.022 79.95 38.9 48.92 39.074 118.618 35.164 161.212-3.905 42.6-28.12 77.333-69.029 77.333-56.774 0-89.338-26.855-115.92-58.98-17.768-21.474-56.007-85.194-98.992-106.168-42.98-20.968-156.562-5.243-194.07-40.629C514.85 1195.833 506 1109.965 506 1066.427c0-49.803 11.189-105.205 72.406-120.93 61.218-15.73 131.552 24.899 158.906 56.36 27.353 31.455 48.19 93.057 89.871 116.648M745.63 735.921c5.458-77.289 79.132-166.791 111.875-221.04 32.743-54.24 48.203-129.607 113.242-100.348 70.136 31.555 64.803 337.663 56.616 398.682-8.182 61.024-35.472 86.527-55.254 98.999-19.782 12.467-73.674 44.748-137.798 21.7-64.124-23.059-94.139-120.699-88.68-197.993"
  //       />
  //     </g>
  //   </g>
  // </svg>

  <svg
    width="1657"
    height="1776"
    viewBox="0 0 1657 1776"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    role="presentation"
    className={className}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M466.192 52.5L920.039 349.286L1656.5 350.42L1655.69 1757.07V1775.5H342.767L53.5 575.398L466.192 52.5Z"
      fill="#409CFD"
    />
    <path
      d="M867.671 301.378L868.292 301.785L869.035 301.786L1603 302.916L1602.19 1707.07V1723H293.736L5.21506 525.993L415.738 5.84392L867.671 301.378Z"
      fill="currentColor"
      stroke="#409CFD"
      strokeWidth="5"
    />
    <g className="areas">
      <rect x="1363.21" y="913.746" width="161.153" height="299.56" fill="#409CFD" />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M1461.17 1023.56H1426.4C1415.2 1023.56 1406.12 1032.64 1406.12 1043.84V1078.61C1406.12 1089.81 1415.2 1098.89 1426.4 1098.89H1461.17C1472.37 1098.89 1481.45 1089.81 1481.45 1078.61V1043.84C1481.45 1032.64 1472.37 1023.56 1461.17 1023.56ZM1414.81 1043.84C1414.81 1037.44 1420 1032.25 1426.4 1032.25H1461.17C1467.57 1032.25 1472.76 1037.44 1472.76 1043.84V1078.61C1472.76 1085.01 1467.57 1090.2 1461.17 1090.2H1449.58V1032.26H1440.88V1090.2H1426.4C1420 1090.2 1414.81 1085.01 1414.81 1078.61V1043.84Z"
        fill="#6FC3F6"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M1472.4 1121.62C1472.88 1121.18 1472.88 1120.37 1472.4 1119.84L1468.52 1116.27C1468.05 1115.74 1467.2 1115.74 1466.63 1116.27L1450.16 1131.87C1448.65 1133.66 1440.89 1135.79 1437.48 1131.87L1420.92 1116.27C1420.44 1115.83 1419.59 1115.83 1419.02 1116.27L1415.24 1119.84C1414.67 1120.37 1414.67 1121.18 1415.24 1121.71L1436.06 1141.32C1437.38 1142.48 1439.09 1143.2 1440.89 1143.2H1446.66C1448.46 1143.2 1450.16 1142.48 1451.49 1141.32L1472.4 1121.62Z"
        fill="#6FC3F6"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M1415.16 1002.26C1414.69 1002.7 1414.69 1003.5 1415.16 1004.04L1419.04 1007.61C1419.52 1008.14 1420.37 1008.14 1420.94 1007.61L1437.4 992.004C1438.92 990.212 1446.68 988.086 1450.09 992.004L1466.65 1007.61C1467.12 1008.05 1467.97 1008.05 1468.54 1007.61L1472.33 1004.04C1472.9 1003.5 1472.9 1002.7 1472.33 1002.17L1451.51 982.553C1450.18 981.395 1448.48 980.68 1446.68 980.68L1440.91 980.68C1439.11 980.68 1437.4 981.395 1436.08 982.553L1415.16 1002.26Z"
        fill="#6FC3F6"
      />
      <path
        d="M1593.15 1371.46L1556.61 1311.43L1471.6 1381.52L1491.74 1413.21L1593.15 1371.46Z"
        fill="#409CFD"
      />
      <path
        d="M903.573 822.29L797.454 901.489L869.24 994.344L974.579 915.145L903.573 822.29Z"
        fill="#409CFD"
      />
      <path
        d="M684.577 480.989C655.547 515.6 629.859 575.09 624.563 604.506C618.282 639.396 624.563 726.626 670.62 762.215C716.678 797.804 775.295 786.638 820.654 748.956C866.013 711.273 854.15 618.463 852.056 514.487C849.963 410.512 824.841 352.592 789.251 348.405C753.662 344.218 732.727 394.461 728.54 407.021C724.353 419.582 720.864 437.726 684.577 480.989Z"
        fill="#409CFD"
      />
      <path
        d="M530.005 845.725C449.621 821.125 417.116 867.25 410.528 876.915C394.562 894.7 387.755 940.167 388.395 974.251C389.034 1008.34 396.071 1063.17 415.902 1107.31C435.734 1151.45 505.462 1157.85 582.228 1161.69C658.994 1165.52 692.899 1223.74 708.252 1249.33C723.605 1274.91 765.187 1323.53 826.6 1336.33C888.012 1349.12 912.961 1315.22 920.638 1249.33C928.314 1183.44 902.726 1122.66 882.894 1095.16C863.063 1067.65 804.979 1050.42 746.119 1033.29C687.258 1016.16 660.464 960.373 649.043 940.167C637.623 919.961 610.389 870.325 530.005 845.725Z"
        fill="#409CFD"
      />
      <path d="M229.141 787.499V822.442H275.125V787.499H229.141Z" fill="#409CFD" />
      <path
        d="M553.177 176.696L427.949 105.672L355.991 230.896L482.152 302.543L553.177 176.696Z"
        fill="#409CFD"
      />
      <path
        d="M1527.56 437.796L1506.47 420.223C1494.75 438.968 1471.32 476.457 1471.32 532.691C1471.32 577.679 1501.78 619.386 1517.01 634.616L1534.59 617.043C1521.7 605.327 1495.93 572.055 1495.93 532.691C1495.93 493.328 1517.01 453.026 1527.56 437.796Z"
        fill="#409CFD"
      />
      <rect x="1573.25" y="752.902" width="31.8293" height="56.2341" fill="#409CFD" />
      <path
        d="M494.921 324.486L368.844 254.617L297.414 378.351L423.88 449.39L494.921 324.486Z"
        fill="#409CFD"
      />
      <path
        d="M387.538 451.591L266.661 373.97L188.637 495.251L310.726 572.465L387.538 451.591Z"
        fill="#409CFD"
      />
      <path
        d="M123.036 460.633L102.418 444.462L368.831 97.605L390.257 114.178L123.036 460.633Z"
        fill="#409CFD"
      />
      <path
        d="M438.891 623.446L301.213 585.761L263.529 724.93L403.446 763.361L438.891 623.446Z"
        fill="#409CFD"
      />
      <path
        d="M251.827 752.82L108.315 747.278L113.859 602.533L258.603 609.309L251.827 752.82Z"
        fill="#409CFD"
      />
      <path d="M311.692 835.738H276.221V881.742H311.692V835.738Z" fill="#409CFD" />
      <path d="M311.691 893.347H277.726V939.564H311.691V893.347Z" fill="#409CFD" />
      <path d="M253.647 933.118H206.354V967.299H253.647V933.118Z" fill="#409CFD" />
      <path d="M193.457 917.636H158.631V870.989H193.457V917.636Z" fill="#409CFD" />
      <path
        d="M179.269 855.728L157.128 828.214L193.673 800.697L215.385 828.214L179.269 855.728Z"
        fill="#409CFD"
      />
      <path
        d="M1121.53 885.727L1095 1012.13L1222.19 1039.05L1247.55 912.646L1121.53 885.727Z"
        fill="#409CFD"
      />
      <path
        d="M1241.78 1105.18L1086.9 1127.85L1109.96 1283.89L1266.38 1262.75L1241.78 1105.18Z"
        fill="#409CFD"
      />
      <path
        d="M333.099 1245.49L344.724 1367.77L511.786 1354L501.022 1230.42L333.099 1245.49Z"
        fill="#409CFD"
      />
      <path
        d="M455.38 1578.76L336.111 1558.09L356.779 1440.11L476.909 1459.49L455.38 1578.76Z"
        fill="#409CFD"
      />
      <path
        d="M659.051 1509.97L553.177 1447.02L621.494 1338.99L726.654 1402.3L659.051 1509.97Z"
        fill="#409CFD"
      />
      <path
        d="M773.447 1520.64L666.072 1577.97L721.124 1685.35L828.5 1629.84L773.447 1520.64Z"
        fill="#409CFD"
      />
      <path
        d="M1428.73 1256.4L1448.03 1263.43L1458.3 1281.22L1454.74 1301.45L1439 1314.66H1418.45L1402.71 1301.45L1399.15 1281.22L1409.42 1263.43L1428.73 1256.4Z"
        fill="#409CFD"
      />
      <rect x="1048.98" y="301.545" width="239.834" height="428.442" fill="#409CFD" />
      <rect x="1125.7" y="1446.59" width="479.799" height="278.905" fill="#409CFD" />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M1605.14 419.805C1587.46 445.243 1581.08 468.673 1580.28 479.975L1604.88 487.005C1604.95 486.537 1605.02 486.05 1605.11 485.545C1605.11 467.183 1605.12 449.764 1605.13 433.394C1605.13 428.78 1605.14 424.25 1605.14 419.805Z"
        fill="#409CFD"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M1605.08 662.493C1597.37 659.042 1591.23 655.325 1587.31 652.188L1573.25 669.762C1583.73 679.077 1594.59 685.306 1605.08 689.471C1605.08 680.385 1605.08 671.39 1605.08 662.493Z"
        fill="#409CFD"
      />
    </g>
  </svg>
);

PlanHuman.propTypes = {
  className: PropTypes.string
};

export default PlanHuman;
